import { render } from "./XMarkIcon.vue?vue&type=template&id=cb863c80&scoped=true"
const script = {}

import "./XMarkIcon.vue?vue&type=style&index=0&id=cb863c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb863c80"]])

export default __exports__